import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface EntityService {
  getById(id: string): Promise<any>;
}

interface UseSuiviEntityConfig {
  service: EntityService;
  entitiesKey: 'commandes' | 'prestataires'; // Clé pour accéder aux entités enfants
}

export const useSuiviEntity = (config: UseSuiviEntityConfig) => {
  const { id } = useParams<{ id: string }>();
  const [entity, setEntity] = useState<any>(null);
  const [selectedPrestataire, setSelectedPrestataire] = useState<number | null>(null);
  const [techNotes, setTechNotes] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEntityDetails = async () => {
      if (!id) return;

      setLoading(true);
      setError(null);

      try {
        const data = await config.service.getById(id);
        setEntity(data);

        // Sélection automatique du prestataire
        const entities = data[config.entitiesKey];
        if (entities?.length > 0) {
          const selected = entities.findIndex((item: any) =>
            config.entitiesKey === 'commandes' ? item.id_status >= 8 : item.selected
          );
          setSelectedPrestataire(selected !== -1 ? selected : 0);
        }

        // Initialisation des notes techniques
        if (entities) {
          const techNotesInit = {};
          entities.forEach((item: any, index: number) => {
            if (item.note_technique) {
              techNotesInit[index.toString()] = {
                organisation: {
                  note: item.note_technique.note_operationnel || 0,
                  commentaire: item.note_technique.commentaire_operationnel || '',
                  description: item.note_technique.description_operationnel || ''
                },
                moyens: {
                  note: item.note_technique.note_humain || 0,
                  commentaire: item.note_technique.commentaire_humain || '',
                  description: item.note_technique.description_humain || ''
                },
                social: {
                  note: item.note_technique.note_environnement || 0,
                  commentaire: item.note_technique.commentaire_environnement || '',
                  description: item.note_technique.description_environnement || ''
                }
              };
            }
          });
          setTechNotes(techNotesInit);
        }
      } catch (err: any) {
        setError(err.message || 'Erreur lors du chargement');
      } finally {
        setLoading(false);
      }
    };

    fetchEntityDetails();
  }, [id, config.service, config.entitiesKey]);

  return {
    entity,
    setEntity,
    selectedPrestataire,
    setSelectedPrestataire,
    techNotes,
    setTechNotes,
    loading,
    error
  };
};